import React from "react";
import { Link } from "react-router-dom";
import errorLogo from '../../assets/images/erroLogo.png'
export default function ErrorView() {
    return (
        <section className="vh-100 d-flex justify-content-center align-items-center">
            <div className="d-flex flex-column justify-content-center align-items-center ">
                <Link to={"/"}>
                    <img
                        src={errorLogo}
                        className="ps-lg-3 w-100 mb-4"
                        alt="error-logo"
                        style={{
                            maxWidth: "100px",
                        }}
                    />
                </Link>
                <h1 className="color_F24444 fs_24 font_montserrat mb-1">
                    Oops Something Went Wrong!
                </h1>{" "}
                <p className="fs_12">Please reload the page or check server</p>
            </div>
        </section>
    );
}